<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn_130">
      <el-select class="select_btn_style" v-model="filters.isTemp" placeholder="是否临时用户">
        <el-option v-for="(item, i) in isTempData" :key="i" :label="item.paramValue" :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.userStatus" placeholder="用户状态">
        <el-option v-for="(item, i) in sharedData" :key="i" :label="item.paramValue" :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input prefix-icon="el-icon-search" v-model="filters.name" placeholder="姓名/手机号"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
// import { getRoleList } from "@/api/role";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: {},
      sharedData: [],
      isTempData: [],
      // roleData: [],
    };
  },
  created() {
    getSysParamByTypes({ types: ["USER_STATUS", "IS_VALID"] }).then((res) => {
      if (!res || res.code != 0) return;
      res.data["USER_STATUS"].splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      res.data["IS_VALID"].splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.sharedData = res.data["USER_STATUS"] || [];
      this.isTempData = res.data["IS_VALID"] || [];
    });

    /* getRoleList().then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        uuid: "",
        roleName: "全部",
      });
      this.roleData = res.data.map((ele) => ({
        paramKey: ele.uuid,
        paramValue: ele.roleName,
      }));
    }); */
  },
  methods: {
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
